import ApplyBrandingDetails from './ApplyBrandingDetails'
import ApplyTexturingDetails from './ApplyTexturingDetails'
import Generate3DModelDetails from './Generate3DModelDetails'
import OrderPartDetails from './OrderPartDetails'
import { useTheme } from 'styled-components'

const OrderedServicesDetails = ({
  record,
  onAcceptOrder,
  onRejectOrder,
  isOrderAccepted,
  isOrderRejected,
  isMyServicesPage,
}) => {
  const theme = useTheme()
  const renderOrderDetails = (record) => {
    switch (record.service_name) {
      case 'Generate 3D Model':
        return (
          <Generate3DModelDetails
            record={record}
            theme={theme}
            onAcceptOrder={onAcceptOrder}
            onRejectOrder={onRejectOrder}
            isOrderAccepted={isOrderAccepted}
            isOrderRejected={isOrderRejected}
            isMyServicesPage={isMyServicesPage}
          />
        )
      case 'Apply Branding':
        return (
          <ApplyBrandingDetails
            record={record}
            theme={theme}
            onAcceptOrder={onAcceptOrder}
            onRejectOrder={onRejectOrder}
            isOrderAccepted={isOrderAccepted}
            isOrderRejected={isOrderRejected}
            isMyServicesPage={isMyServicesPage}
          />
        )
      case 'Apply Texturing':
        return (
          <ApplyTexturingDetails
            record={record}
            theme={theme}
            onAcceptOrder={onAcceptOrder}
            onRejectOrder={onRejectOrder}
            isOrderAccepted={isOrderAccepted}
            isOrderRejected={isOrderRejected}
            isMyServicesPage={isMyServicesPage}
          />
        )
      case 'Order Part':
        return <OrderPartDetails record={record} />
      default:
        return null
    }
  }

  return renderOrderDetails(record)
}

export default OrderedServicesDetails
